import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

function CustomUniversalSelect({
  options,
  value,
  onChange,
  ariaLabel,
  hideCheckBox,
  solidArrowIcon,
}) {
  const newRef = useRef(null);
  useEffect(() => {
    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    };
  });

  const [isListOpen, setIsListOpen] = useState('');
  const arrowStyle = solidArrowIcon ? 'caret' : 'angle';

  const paramOption = options.find(option => option.value === value) || options[0],
        headerOption = options.find(option => option.selected) || paramOption,
        headerTitle = headerOption?.label;

  const handleClick = e => {
    if (!newRef.current.contains(e.target)) {
      setIsListOpen(false);
    }
  };

  const toggleList = () => {
    setIsListOpen(prevState => !prevState);
  };

  const selectItem = item => {
    const { value } = item;
    setIsListOpen(false);
    onChange(value);
  };

  const handleKeyPress = event => {
    if (event.key === 'Escape') {
      event.preventDefault();
  
      setIsListOpen(false);
    }
  };

  const $options = options.map((option, i) => {
    if (value == option.label) {
      value = option.value;
    }
    return (
      <button
        key={i}
        className={classNames(
          'btn bg-white btn-select-option w-100 text-left d-flex d-flex-row ',
          { selected: option.selected }
        )}
        onClick={() => selectItem(option)}
        value={'' + option.value}
        disabled={!!option.disabled}>
        <i
          className={classNames(
            option.label === headerTitle
              ? 'fa fa-check mr-1 pt-1'
              : 'select-space',
            {
              'd-none': hideCheckBox,
            }
          )}
        />
        <span>{option.label}</span>
      </button>
    );
  });

  return (
    <div className="custom-universal-select" ref={newRef}>
      <button
        type="button"
        className="btn btn-white"
        onClick={toggleList}
        aria-label={`${ariaLabel} ${headerTitle}`}
        aria-expanded={isListOpen}
        onKeyDown={handleKeyPress}>
        <span className="mr-5 header-title">{headerTitle}</span>
        <i
          className={classNames(
            'fa',
            isListOpen ? `fa-${arrowStyle}-up` : `fa-${arrowStyle}-down`
          )}
        />
      </button>
      {isListOpen && (
        <div role="list" className="select-list" onKeyDown={handleKeyPress}>
          {$options}
        </div>
      )}
    </div>
  );
}

CustomUniversalSelect.propTypes = {
  options: PropTypes.array.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
  solidArrowIcon: PropTypes.bool,
  hideCheckBox: PropTypes.bool,
};

CustomUniversalSelect.defaultProps = {
  solidArrowIcon: false,
  hideCheckBox: false,
};

export default CustomUniversalSelect;
